module.exports = __webpack_public_path__ + "static/img/app_ivoice_sc.4dc1914.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/app_ivoice_sc.png
// module id = 452
// module chunks = 0